import {
	GET_INSTRUCTIONS,
	POST_INSTRUCTIONS,
	UPDATE_INSTRUCTIONS,
	PATCH_SECTIONS,
	DELETE_INSTRUCTION,
	DELETE_CUSTOM_SECTION,
	SET_GROUP_AUDIT_DOCUMENT_UPLOAD
} from '../actiontypes';
import {
	getAllInstructionsUrl,
	patchGroupInstructionsUrl,
	GroupSectionsUrl,
	deleteInstructionUrl,
	deleteSectionUrl
} from '../apiUrls';
import {KnowledgeSections, jsonDocumentPatchOperations} from '../../util/uiconstants';
import {patchGeneratorPayload} from './patchGeneratorPayload';
import Utility from '../../util/utilityfunctions';
/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request to get all the active instructions for a specific section for the given engagements.
 * @param {Number} engagementId Engagement ID.
 * @param {Array} knowledgeSections array of the knowledge sections IDs the user want to get.
 * @param {Boolean} showCustomSections boolean decide whether we get Custom Sections or not.
 * @returns {Object} An action object.
 */
export const getAllInstructions = (engagementId, knowledgeSections, showCustomSections = false) => {
	const url =
		getAllInstructionsUrl(engagementId) +
		'?' +
		addKnowledgeSectionsParams(knowledgeSections) +
		'includeCustomSections=' +
		showCustomSections;
	return {
		type: GET_INSTRUCTIONS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const CreateInstruction = (engagementId, payload) => {
	const url = getAllInstructionsUrl(engagementId);

	return {
		type: POST_INSTRUCTIONS,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		}
	};
};

export const UpdateInstruction = (engagementId, instructionId, payload) => {
	const url = patchGroupInstructionsUrl(engagementId, instructionId);
	const data = patchGeneratorPayload(payload);
	return {
		type: UPDATE_INSTRUCTIONS,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const UpdateInstructionAsync = async function(store, documentId) {
	const state = store.getState();

	const payload = {
		sectionId: state.groupAudit?.groupAuditDocumentUploadOn?.sectionId,
		Documents: [
			{
				id: documentId,
				checked: true
			}
		]
	};
	const url = patchGroupInstructionsUrl(
		state.groupAudit?.groupAuditDocumentUploadOn?.engagementId,
		state.groupAudit?.groupAuditDocumentUploadOn?.instructionId
	);
	const data = patchGeneratorPayload(payload);

	await store.dispatch({
		type: 'UPDATE_INSTRUCTIONS',
		meta: {
			api: {
				url: url,
				data: data,
				method: 'PATCH'
			}
		}
	});
};

const addKnowledgeSectionsParams = (knowledgeSections) => {
	if (!knowledgeSections) return '';
	const params = knowledgeSections.reduce(
		(accum, current) => accum + 'knowledgeSections=' + KnowledgeSections[current] + '&',
		''
	);
	return params;
};

export const editInstructionSectionName = (engagementId, sectionId, sectionName) => {
	const url = `${GroupSectionsUrl(engagementId)}/${sectionId}`;

	return {
		type: PATCH_SECTIONS,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: [
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, `GroupSectionName`, sectionName)
				]
			}
		}
	};
};

export const deleteInstruction = (engagementId, instructionId) => {
	const url = deleteInstructionUrl(engagementId, instructionId);
	return {
		type: DELETE_INSTRUCTION,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		instructionId
	};
};

export const deleteSection = (engagementId, sectionId) => {
	const url = deleteSectionUrl(engagementId, sectionId);

	return {
		type: DELETE_CUSTOM_SECTION,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		sectionId
	};
};

export const setGroupAuditDocumentUploadOn = (engagementId, sectionId, instructionId) => {
	return {
		type: SET_GROUP_AUDIT_DOCUMENT_UPLOAD,
		engagementId,
		sectionId,
		instructionId
	};
};
